export default {
    data() {
        return {
            mixinsBoard_isShowContent: true
        }
    },
    methods: {
        mixinsBoard_collapseContent(value) {
            this.mixinsBoard_isShowContent = value;
        }
    }
}